export default "__VITE_ASSET__910327ad__"